import React, { useState, useEffect } from "react";
import {
  FaBoxOpen, FaMoneyBillWave, FaTags, FaFileAlt, FaListUl, FaUser, FaPhone, FaEnvelope, FaBuilding, FaMapMarkerAlt, FaFileInvoice, FaImage, FaIdCard, FaFilePdf, FaSearch, FaPlus, FaTimes
} from "react-icons/fa";

import axios from 'axios'
import toast from "react-hot-toast";
import Select from 'react-select';
import { Button, Card } from "react-bootstrap";
import { MdDeleteForever } from "react-icons/md";
import { useRef } from "react";


function BusinessCategory({token}) {

     const [showForm, setShowForm] = useState(false);
          const [editingCompanyId, setEditingCompanyId] = useState(null);
          const [isEditMode, setIsEditMode] = useState(false);
          const [searchTerm, setSearchTerm] = useState('');
          const [category, setCategory] = useState([]);
          const [showDeleteModal, setShowDeleteModal] = useState(false);
          const [selectedDelete, setSelectedDelete] = useState(null);
          const [file, setFile] = useState(null);
          const [excelData, setExcelData] = useState([]);
          const fileInputRef = useRef(null);
        const [selectedUser, setSelectedUser] = useState(null);
        const [showStatusModal, setShowStatusModal] = useState(false);
     const [showActive, setShowActive] = useState(true);


          const [formData, setFormData] = useState({
                 buss_name:'',
                
                  });
                

                   const handleInputChange = (e) => {
          const { name, value, files } = e.target;
          if (name === "profile") {
            setFormData({ ...formData, [name]: files[0] });
          } else {
            setFormData({ ...formData, [name]: value });
          }
        };


const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    if (isEditMode) {
      await axios.put(
        `https://api.krimotion.in/update-business-category/${formData.id}`,
        {
          buss_name: formData.buss_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Business Category updated successfully!");
    } else {
      await axios.post(
        "https://api.krimotion.in/add-business-category",
        {
          buss_name: formData.buss_name,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Business Category Added Successfully!");
    }

    resetForm();
    setShowForm(false);
    setIsEditMode(false);
    fecthBusinesCat();

  } catch (err) {
    toast.error("Operation failed!");
    console.error(err);
  }
};


    const fecthBusinesCat = async () => {
    try {
      const res = await axios.get("https://api.krimotion.in/fetch-business-category",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      const result = res.data;

      setCategory(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fecthBusinesCat();

  }, []);


    const handleDeleteCategory = async () => {
    try {
      const res = await axios.delete(
        `https://api.krimotion.in/delete-business-category/${selectedDelete.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Deleted Successfuly!");

      setShowDeleteModal(false);
      setSelectedDelete(null);

      fecthBusinesCat();
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
    }
  };

  const handleEdit = (form) => {

  setIsEditMode(true);
 
  setFormData({
    id: form.id || "",
   buss_name: form.buss_name || "",

  });

  setEditingCompanyId(form.id);
  setShowForm(true);
};


    const resetForm = () => {
    setFormData({
   buss_name:'',

    });

    setIsEditMode(false);
    setEditingCompanyId(null);


  };


      const handleStatusUpdate = async (user) => {
  try {
    const currentStatus = user.is_active;
    const newStatus = currentStatus === '1' ? '0' : '1';

    await axios.put(
      `https://api.krimotion.in/update-buss-cat-status/${user.id}`,
      {
        is_active: newStatus,
      },
       {
          headers: {
             Authorization: `Bearer ${token}`,
          },
        }
    );

    toast.success("Status updated successfully!");

    setShowStatusModal(false);
  
      fecthBusinesCat();

  } catch (error) {
    console.log(error);
    toast.error("Failed to update status");
  }
};


    // const filteredData = Array.isArray(category)
    // ? category.filter(itm =>
    //   Object.values(itm).some(val =>
    //     String(val).toLowerCase().includes(searchTerm.toLowerCase())
    //   )
    // )
    // : [];


      const filteredData = Array.isArray(category)
  ? category.filter((itm) => {
      const matchesSearch = Object.values(itm).some((val) =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      );

      const matchesStatus = showActive
        ? Number(itm.is_active) === 1
        : Number(itm.is_active) === 0;

      return matchesSearch && matchesStatus;
    })
  : [];


  return (
       <div className="container py-4">
            <div className="border-0  mb-3 px-2 py-2  ">
      
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
      
                {/* LEFT TITLE */}
                <div className="d-flex align-items-center">
                  <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                    Manage Business Category
                  </h4>
                </div>
      
                {/* CENTER SEARCH */}
                <div style={{ flex: 1, maxWidth: "250px" }}>
                  <div
                    className="d-flex align-items-center rounded-pill overflow-hidden"
                    style={{
                      border: "1px solid var(--green)",
                      height: "34px",
                      paddingLeft: "8px",
                      paddingRight: "8px",
                      backgroundColor: 'white'
                    }}
                  >
                    {/* ICON */}
                    <FaSearch
                      style={{
                        color: "var(--green)",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center"
                      }}
                    />
      
                    {/* INPUT */}
                    <input
                      type="text"
                      className="form-control border-0 shadow-none"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      style={{
                        fontSize: "14px",
                        height: "32px",
                        marginLeft: "6px",
                        lineHeight: "32px"
                      }}
                    />
                  </div>
                </div>
      
                {/* RIGHT BUTTON */}
                <div className="d-flex align-items-center gap-2">
                  {!showForm ? (
                    <>
                      <button
                        className="btn btn-sm px-3 "
                        onClick={() => setShowForm(true)}
                        style={{
                          backgroundColor: "var(--green)",
                          color: "white",
                          fontSize: "13px",
                          height: "34px"
                        }}
                      >
                        <FaPlus className="me-1" />
                        Add
                      </button>
      
                    </>
                  ) : (
                    <button
                      className="btn btn-danger btn-sm px-3"
                      onClick={() => {
                        resetForm();
                        setShowForm(false);
                      }}
                      style={{ height: "34px", fontSize: "13px" }}
                    >
                      <FaTimes className="me-1" />
                      Close
                    </button>
                  )}
                </div>
      
              </div>
            </div>
      
    
      
      
            {showForm && (
              <div className="card shadow-sm border-0 rounded-4 p-3">
      
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
      
      
                    <div className="col-md-4">
                      <label className="form-label fw-semibold">Business Name</label>
                      <div className="input-group">
                        <span className="input-group-text">
                          <FaBoxOpen />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter name"
                          name="buss_name"
                          value={formData.buss_name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
      

                    {/* Save Button */}
                    <div className="col-12 text-end">
                      <button type="submit" className="btn-action btn-success-custom" style={{ backgroundColor: "var(--green)", color: 'white' }}>
                        {isEditMode ? "Update  " : " Save "}
                      </button>
                    </div>
      
                  </div>
                </form>
              </div>
            )}
      
           
    {!showForm && (


<> 

  <div className="d-flex justify-content-end mb-3">
  <div
    className="d-flex align-items-center px-3 py-2 rounded-pill shadow-sm"
    style={{
      background: "#fff",
      border: "1px solid #e5e7eb",
      gap: "4px",
    }}
  >
    <span
      className={`fw-semibold ${
        showActive ? "text-success" : "text-danger"
      }`}
      style={{ minWidth: "100px" }}
    >
      {showActive ? "Active Items" : "Deactivated Items"}
    </span>

    <div className="form-check form-switch m-0">
      <input
        className="form-check-input"
        type="checkbox"
        checked={!showActive}
        onChange={() => setShowActive(!showActive)}
        style={{
          width: "3rem",
          height: "1.5rem",
          cursor: "pointer",
        }}
      />
    </div>
  </div>
</div>
      <div className="container-fluid mt-4">
        <div className="row g-4">
    
          {filteredData.length > 0 ? (
            filteredData.map((dealer, index) => (
    
              <div className="col-xl-4 col-lg-6 col-md-6" key={index}>
    
                <div className="inventory-card d-flex flex-column h-100">
    
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-3">
    
                    <h5 className="fw-bold mb-0">
                      {dealer.buss_name}
                    </h5>
    
                   
    
                  </div>
    
                  {/* Details */}
    
                  <div className="inventory-row">
                    <span className="inventory-label">
                     Category Name
                    </span>
    
                    <span>{dealer.buss_name}</span>
                  </div>
    
                  {/* Bottom Action */}
    
              <div className="mt-auto pt-3 d-flex justify-content-end gap-2">
    
      <button
        className="btn-action btn-primary-custom"
        onClick={() => handleEdit(dealer)}
      >
        <i className="bi bi-pencil me-1"></i>
        Edit
      </button>
    
      {/* <button
        className="btn-action btn-danger-custom"
        onClick={() => {
          setSelectedDelete(dealer);
          setShowDeleteModal(true);
        }}
      >
        <i className="bi bi-trash me-1"></i>
        Delete
      </button> */}

       <button
    className={`btn-action me-2 ${
      dealer.is_active == 1
        ? "btn-danger-custom"
        : "btn-success-custom"
    }`}
    onClick={() => {
      setSelectedUser(dealer);
      setShowStatusModal(true);
    }}
  >
    <i className="bi bi-pencil"></i>{" "}
    {dealer.is_active == 1 ? "Remove" : "Added"}
  </button>
    
    </div>
    
                </div>
    
              </div>
    
            ))
          ) : (
    
            <div className="col-12">
              <div className="text-center py-5">
                No Data Found
              </div>
            </div>
    
          )}
    
        </div>
      </div>

      </>
    )}
            
                  {showDeleteModal && (
                    <>
                      <div
                        className="modal-backdrop fade show"
                        onClick={() => {
                          setShowDeleteModal(false);
                          setSelectedDelete(null);
                        }}
                      ></div>
      
                      <div className="modal fade show d-block">
                        <div className="modal-dialog modal-dialog-centered">
                          <div
                            className="modal-content border-0 shadow-lg"
                            style={{ borderRadius: "16px" }}
                          >
      
                            <div className="modal-header bg-danger text-white">
                              <h5 className="modal-title fw-bold">
                                🗑 Delete Category
                              </h5>
      
                              <button
                                className="btn-close btn-close-white"
                                onClick={() => setShowDeleteModal(false)}
                              ></button>
                            </div>
      
      
                            <div className="modal-body text-center py-4">
      
                              <div style={{ fontSize: "60px" }}>⚠️</div>
      
                              <h5 className="mt-3 fw-bold">
                                Are you sure?
                              </h5>
      
                              <p className="text-muted mb-0">
                                You are about to permanently delete this category.
                              </p>
      
                              <h6 className="fw-bold text-dark mt-2">
                                {selectedDelete?.name}
                              </h6>
      
                              <p className="text-danger fw-semibold mt-2">
                                This action cannot be undone.
                              </p>
      
                            </div>
      
      
                            <div className="modal-footer border-0 justify-content-center">
      
                              <button
                                className="btn btn-outline-secondary px-4"
                                onClick={() => {
                                  setShowDeleteModal(false);
                                  setSelectedDelete(null);
                                }}
                              >
                                Cancel
                              </button>
      
                              <button
                                className="btn btn-danger px-4"
                                onClick={handleDeleteCategory}
                              >
                                🗑 Delete
                              </button>
      
                            </div>
      
                          </div>
                        </div>
                      </div>
                    </>
                  )}


                    {showStatusModal && (
  <div
    className="modal d-block"
    tabIndex="-1"
    style={{
      background: "rgba(15, 15, 15, 0.55)",
      backdropFilter: "blur(6px)",
    }}
  >
    <div className="modal-dialog modal-dialog-centered">
      <div
        className="modal-content border-0 rounded-4 shadow-lg"
        style={{
          overflow: "hidden",
        }}
      >

        {/* HEADER */}
        <div
          className="modal-header border-0"
          style={{
            background: "linear-gradient(135deg, var(--green), #0ea57a)",
            color: "white",
          }}
        >
          <h5 className="modal-title fw-semibold">
            Confirm Status Change
          </h5>

          <button
            className="btn-close btn-close-white"
            onClick={() => setShowStatusModal(false)}
          />
        </div>

        {/* BODY */}
        <div className="modal-body text-center p-4">

          <div
            style={{
              width: "70px",
              height: "70px",
              margin: "0 auto 15px",
              borderRadius: "50%",
              background:
                selectedUser?.is_active == "1"
                  ? "rgba(220, 53, 69, 0.1)"
                  : "rgba(25, 135, 84, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "28px",
            }}
          >
            {selectedUser?.is_active == "1" ? "⚠️" : "✔️"}
          </div>

          <h5 className="fw-bold mb-2">
            {selectedUser?.is_active == "1"
              ? "Deactivate Business Category?"
              : "Activate Business Category ?"}
          </h5>

          <p className="text-muted mb-2">
            You are about to change status for
          </p>

          <h6 className="fw-semibold text-dark mb-3">
            {selectedUser?.buss_name}
          </h6>

          <div
            className="px-3 py-2 rounded-pill d-inline-block"
            style={{
              background:
                selectedUser?.is_active == "1"
                  ? "#ffe3e3"
                  : "#e6f7ee",
              color:
                selectedUser?.is_active == "1"
                  ? "#dc3545"
                  : "#198754",
              fontWeight: 600,
              fontSize: "13px",
            }}
          >
            Current Status:{" "}
            {selectedUser?.is_active == "1" ? "Active" : "Inactive"}
          </div>
        </div>

        {/* FOOTER */}
        <div className="modal-footer border-0 d-flex justify-content-center gap-2 pb-4">

          <button
            className="btn btn-light px-4 rounded-pill"
            onClick={() => setShowStatusModal(false)}
          >
            Cancel
          </button>

          <button
            className="btn px-4 rounded-pill text-white"
            style={{
              background:
                selectedUser?.is_active == "1"
                  ? "#dc3545"
                  : "var(--green)",
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
            }}
            onClick={() => handleStatusUpdate(selectedUser)}
          >
            {selectedUser?.is_active == "1"
              ? "Deactivate"
              : "Activate"}
          </button>

        </div>

      </div>
    </div>
  </div>
)}
          </div>
  )
}

export default BusinessCategory
